/** Converte o HTML do editor para a página, inclusive texto antigo sem marcas. */
export function sobreRichHtml(raw: string | null | undefined): string {
  const source = String(raw ?? '')
    .replace(/&nbsp;|&#160;|&#x0*a0;/gi, ' ')
    .replace(/\u00A0/g, ' ')
    .trim();
  if (!source) {
    return '';
  }
  if (!/<\/?[a-z][\s\S]*>/i.test(source)) {
    return source
      .split(/\n{2,}/)
      .map((block) => `<p>${escapeHtml(block).replace(/\n/g, '<br>')}</p>`)
      .join('');
  }

  const tpl = document.createElement('template');
  tpl.innerHTML = source;
  normalizeQuillLists(tpl.content);
  return tpl.innerHTML;
}

export function sobreRichTextVazio(raw: string | null | undefined): boolean {
  return (
    String(raw ?? '')
      .replace(/<[^>]+>/g, ' ')
      .replace(/&nbsp;|&#160;|&#x0*a0;/gi, ' ')
      .replace(/\u00A0/g, ' ')
      .trim().length === 0
  );
}

function escapeHtml(value: string): string {
  return value
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;');
}

function normalizeQuillLists(root: ParentNode): void {
  const lists = Array.from(root.querySelectorAll('ol, ul'));
  for (const list of lists) {
    const items = Array.from(list.children).filter((el): el is HTMLLIElement => el.tagName === 'LI');
    if (!items.length) {
      continue;
    }
    const fragment = document.createDocumentFragment();
    let current: HTMLUListElement | HTMLOListElement | null = null;
    let currentKind: 'ul' | 'ol' | null = null;
    for (const li of items) {
      const dataList = (li.getAttribute('data-list') || '').toLowerCase();
      const kind: 'ul' | 'ol' =
        dataList === 'ordered' || (!dataList && list.tagName === 'OL') ? 'ol' : 'ul';
      li.querySelectorAll('.ql-ui').forEach((node) => node.remove());
      li.removeAttribute('data-list');
      if (!current || currentKind !== kind) {
        current = document.createElement(kind);
        currentKind = kind;
        fragment.appendChild(current);
      }
      current.appendChild(li);
    }
    list.replaceWith(fragment);
  }
}
